
export const locale = { 
    //header.vue
    cname:'Shanghong Shelf Co., Ltd',
    myorder:'My orders',
    car:'Cart',
    myplan:'My Solutions',
    coupon:'Coupons',
    logout:'Quit',
    louout1:'Log-out',
    register:'Register',
    login:'Log-in',
    home:'HOME',
    about:'About Us',
    about1:'Profile',
    about_culture:'Culture',
    about_step:'History',
    about_productive:'Capacity',
    about_authority:'Awards',
    about_partner:'Cooperation',
    solution:'Solutions',
    retail:'Retailing',
    stage:'Display Equipment',
    storage:'Auto-logistics',
    vending:'Vending Machine',
    online_shop:'Online Portal',
    design:'3D Cloud Design',
    server:'Services',
    serve_shop:'Service Network',
    serve:'One-stop Service',
    contactus:'Contact Us',
    contact:'Contact',
    jobs:'Join Us',
    agent:'Apply for Agency',
    supplier:'Supplier Platform',
    
    //bottom.vue
    wechat:'Wechat ID',
    sh_shop:'Online Portal',
    copyright:'Copyright',
    companyname:'Zhejiang Shanghong Shelf Co., Ltd',
    icpno:'ICP Record No.of Zhejiang:13026816-1',
    zgw:'Public Security Record No.of Zhejiang Province: 33042102000240',
    
    //goods.vue
    goodslist:'Product list',
    search: 'Search',
    categories:'Category',
    category_c:'sub-category',
    tags:'Series',
    sort: {
        default1:'Default sort',
        priceAsc:'Price ↑',
        priceDesc:'Price ↓'
    },
    
    //goodsdetail.vue
    goodsdetail1:'Details',
    gogoods:'Back to Home Page',
    goods_sn:'Item Code',
    price:'Price',
    stock:'Inventory quantity',
    piece:'piece',
    specs:'Specification',
    length:'Length',
    width:'Width',
    high:'High',
    color:'Color',
    nums:'Nums',
    server1:'Service',
    return_goods:'Support return within 30 days',
    priority_distribution:'Shunfen priority',
    buynow:'Buy all',
    incar:'Add to Cart',
    goodsdetail:'Product details',
    goods_model:'Product model',
    size:'Size',
    goods_summary:'Product description',
    stock_insufficient:'Understock',
    add_success:'Successfully added',
    
    //car.vue
    mycar:'My shopping cart',
    empty_car:'Nothing in here',
    go_shop:'Visit the shop',
    arrive:'To be delived in 10 days',
    del_goods:'Confirm to delete this item',
    yes:'yes',
    no:'no',
    selectall:'Select all',
    total:'Totalling',
    checkout:'Pay here',
    
    //coupon.vue
    enter_coupon:'Please enter the discount code',
    post:'Submit',
    available:'Availabe',
    used:'Used',
    expired:'Expired',
    discount:'Discount',
    full:'Over',
    minus:'minus',
    universal:'General coupon',
    user:'Use it now',
    all:'all',
    waitpay:'Waiting for payment',
    paid:'Successfully paid',
    completed:'Payment completed',
    delivery:'In delivery',
    delivered:'Successfully delivered',
    refund:'Refound in processing',
    refunded:'Successfully refound',
    cancelled:'Cancelled',
    payfailed:'Payment failed',
    activation_success:'Coupon code successfully activated',
    
    //editplan
    editplan:'Modify my solutions',
    
    //myorder.vue
    goods_information:'Products information',
    unit_price:'Unit Price',
    disbursements:'Actual paid',
    transaction_status:'Transaction status',
    ctime:'Create time',
    order_sn:'Order number',
    order_detail:'Order detail',
    contract:'Contract&Agreement',
    gopay:'Pay now',
    order_cancel:'Cancel',
    confirm_receipt:'Receiving confirmation',
    buy_again:'Buy again',
    terms_agreements:'Terms & Agreements',
    
    //myplan.vue
    plan:'Solutions',
    edit:'Edit',
    del:'Delete',
    
    //order.vue
    confirm_order:'Confirm Order',
    payment:'Payment method',
    shipping_address:'Delivery address',
    add:'Add',
    location:'Location',
    phone:'Tel',
    detail_address:'Detailed location',
    edit1:'Edit',
    default_address:'Default address',
    add_new_address:'Add new address',
    other_address:'Other address',
    addressee:'Addressee',
    address:'Address',
    street:'Street',
    set_default_address:'Default address',
    details:'Product details',
    introduction:'Synopsis',
    white:'White',
    silvery:'Silvery',
    coupon_area:'Discount page',
    user_coupon:'Use coupons or discount code',
    user_coupon1:'Use coupons or discount code',
    piece1:'available',
    activation_coupon:'Activate discount code',
    user_cancel:'Cancel',
    total_price:'Total',
    freight:'Freight',
    payable:'Payable',
    postorder:'Submit',
    select_address:'Choose your delivery address',
    
    //orderdetail.vue
    pay_success:'Paid success',
    goods_delivery:'Pick & Packed',
    order_information:'Order information',
    message:'Leave a message',
    order_status:'Order status',
    logistics:'Logistic information',
    express:'Tracking number',
    status:'Status',
    making:'Making',
    
    //pay.vue
    pay:'Payment',
    payable1:'Actual paid',
    selectpayment:'Choose payment method',
    alipay:'Alipay',
    wechatpay:'Wxpay',
    accept:'I accept clauses and agreements',
    pay1:'Pay now',
    readed:'I have read the contract above',
    check:'Please check clause agreement',
    
    //paysuccess.vue
    paysuccess:'Payment successful',
    actual_payment:'Actual paid',
    view_order:'View order details',
    back_detail:'Detail of online shop',
    
    
    //2022-3-14 new
    Commercial_retail : 'Commercial/Retail',
    shelves : 'Supermarket Gondola',
    store_shelves : 'Membership Hypermart Gondola',
    warehousing_industry : 'Warehouse/Industry',
    beam_type_shelves : 'Selective Pallet Rack',
    narrow_roadway_beam_shelves : 'VNA Rack',
    double_depth_beam_shelves : 'Double Deep Rack',
    drive_in_shelves : 'Drive-in Rack',
    shuttle_shelves : 'Shuttle Rack',
    flow_shelves : 'Flow Rack',
    cantilever_rack_shelves : 'Cantilever Rack',
    duty_racking_shelves: 'Longspan Shelf',
    attic_shelves : 'Multi-tier Rack',
    vertical_warehouse_shelves : 'Automated Storage and Retrieval System',
    logistics_equipment :'Logistics Equipment ',
}


// WEBPACK FOOTER //
// ./src/assets/lang/en.js